export const access_specifier = {
    "1A"  : 'Pro',  // FE 1
    // "1B"  : 'Fe B',  // FE 2
    // "1ds" : 'Fe Ds', // FE Down Sell
    "1a"  : 'FastPass Offer', // FE Bump 1
    "1b"  : 'Masterclass', // FE Bump 2
    "1c"  : 'Cold Reachout Templates', // FE Bump 3

    "2A" : 'Platinum', // OTO1 1
    // "2B" : 'OTO-1B', // OTO1 2
    // "2ds" : 'OTO-1 Ds', // OTO1 Down Sell
    "2a" : 'Lower Third Templates', // OTO1 Bump 1
    // "2b" : 'OTO-1 BUMP-2',  // OTO1 Bump 2
    // "2c" : 'OTO-1 BUMP-3',  // OTO1 Bump 3

    "3A" : 'Template Club', // OTO2 1
    // "3B" : 'OTO-2B', // OTO2 2
    // "3ds" : 'OTO-2 Ds', // OTO2 Down Sell
    // "3a" : 'OTO-2 BUMP-1', // OTO2 Bump 1
    // "3b" : 'OTO-2 BUMP-2', // OTO2 Bump 2
    // "3c" : 'OTO-2 BUMP-3', // OTO2 Bump 3
    
    "4A" : 'Masterclass', // OTO3 1
    // "4B" : 'OTO-3B', // OTO3 2
    // "4ds" : 'OTO-3 Ds', // OTO3 Down Sell
    // "4a" : 'OTO-3 BUMP-1', // OTO3 Bump 1
    // "4b" : 'OTO-3 BUMP-2', // OTO3 Bump 2
    // "4c" : 'OTO-3 BUMP-3', // OTO3 Bump 3

    "5" : "Super Admin", // Super Admin
    
    "6A" : 'LeadAmaze - (Client Finder)', // OTO4 1
    // "6B" : 'OTO-4B', // OTO4 2
    // "6ds" : 'OTO-4 Ds', // OTO4 Down Sell
    // "6a" : 'OTO-4 BUMP-1', // OTO4 Bump 1
    // "6b" : 'OTO-4 BUMP-2', // OTO4 Bump 2
    // "6c" : 'OTO-4 BUMP-3', // OTO4 Bump 3

    "7A" : 'Agency', // OTO5 1
    // "7B" : 'OTO-5B', // OTO5 2
    // "7ds" : 'OTO-5 Ds', // OTO5 Down Sell
    // "7a" : 'OTO-5 BUMP-1', // OTO5 Bump 1
    // "7b" : 'OTO-5 BUMP-2', // OTO5 Bump 2
    // "7c" : 'OTO-5 BUMP-3', // OTO5 Bump 3

    // "10A" : 'OTO-6A', // OTO6 1
    // "10B" : 'OTO-6B', // OTO6 2
    // "10ds" : 'OTO-6 Ds', // OTO6 Down Sell
    // "10a" : 'OTO-6 BUMP-1',  // OTO6 Bump 1  
    // "10b" : 'OTO-6 BUMP-2', // OTO6 Bump 2
    // "10c" : 'OTO-6 BUMP-3', // OTO6 Bump 3

    // "11A" : 'OTO-7A', // OTO7 1
    // "11B" : 'OTO-7B', // OTO7 2
    // "11ds" : 'OTO-7 Ds', // OTO7 Down Sell
    // "11a" : 'OTO-7 BUMP-1', // OTO7 Bump 1
    // "11b" : 'OTO-7 BUMP-2', // OTO7 Bump 2
    // "11c" : 'OTO-7 BUMP-3', // OTO7 Bump 3
    
    // "8" : 'Bundle', // Bundle
    "8A" : 'Ultimate Bundle Offer', // Bundle without template club
    "8B" : 'Ultimate Bundle Offer + Elite Template Club', // Bundle with template club
    "8SB" : 'Super Bundle + 2 Years of Elite Template Club Membership', // Super Bundle with 2 years template club
    // "8M" : 'Mega Bundle', // Mega Bundle 
    // "8SP" : 'Bundle Split Payment Option', // Bundle Split Payment Option
    // "8P" : 'Platinum Bundle' // Platinum Bundle
    "8a" : "VidAmaze Agency Setup", // VidAmaze Agency Setup
    "8b" : "VidAmaze 1000 Credits", // VidAmaze 1000 Credits
}